import { Host, h } from "@stencil/core";
import { requiredLabel, formMessageLogic, formTooltipLogic } from "../../common/form";
import state from "../store";
import { formClasses } from "../../common/classesNames";
import { exportParts } from "../../common/export-parts";
import { commonClassesNames } from "../../common/classesNames";
export class GxgFormTextarea {
    constructor() {
        this.singleLine = false;
        this.ai = false;
        this.toolTip = false;
        this.error = false;
        this.label = undefined;
        this.labelPosition = "above";
        this.labelWidth = undefined;
        this.centerLabel = false;
        this.maxWidth = "100%";
        this.maxHeight = undefined;
        this.height = "auto";
        this.placeholder = undefined;
        this.value = undefined;
        this.rows = 4;
        this.warning = false;
        this.hideValidationMessage = false;
        this.disabled = false;
        this.required = false;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.informationMessage = undefined;
        this.resize = false;
        this.shrink = false;
    }
    parts = {
        textarea: "textarea"
    };
    exportparts;
    el;
    //A reference to the input
    textArea;
    /**
     * Returns the textarea value
     */
    input;
    /**
     * Returns the textarea value
     */
    change;
    /**
     * Emits the enter keydown event. It emits the actual textarea value. Used for the Ai-Assistant
     */
    enter;
    /**
     * Emits the ArrowUp keydown event. Only available if ai is true.
     */
    arrowUpPressed;
    /*VALIDATION*/
    formMessageLogic = formMessageLogic;
    /*********************************
    METHODS
    *********************************/
    componentWillLoad() {
        this.attachExportParts();
        if (this.singleLine) {
            this.blurHandler();
        }
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    updateTextareaValue() {
        this.value = this.textArea.value;
    }
    handleInput = (e) => {
        e.stopPropagation();
        const target = e.target;
        this.value = target.value;
        this.input.emit(this.value);
        if (this.ai) {
            const offset = this.textArea.offsetHeight - this.textArea.clientHeight;
            this.textArea.style.height = "auto";
            this.textArea.style.height = this.textArea.scrollHeight + offset + "px";
        }
    };
    handleChange() {
        //formHandleValidation(this, e.target);
        this.change.emit(this.value);
    }
    focusHandler = () => {
        if (this.singleLine) {
            this.shrink = false;
        }
    };
    blurHandler = () => {
        if (this.singleLine) {
            this.shrink = true;
        }
    };
    keyDownHandler = (e) => {
        if (e.key === "Enter" && !e.shiftKey && this.ai) {
            e.preventDefault();
            this.enter.emit(this.textArea.value);
            this.textArea.style.height = "auto";
        }
        else if (e.key === "ArrowUp" && this.ai) {
            this.arrowUpPressed.emit();
        }
    };
    render() {
        return (h(Host, { role: "textbox", "aria-label": this.label, style: { maxWidth: this.maxWidth }, class: {
                textarea: true,
                large: state.large,
                mercury: state.mercury,
                shrink: this.singleLine && this.shrink,
                [formClasses["VALIDATION_INDETERMINATE_CLASS"]]: this.validationStatus === "indeterminate",
                [formClasses["VALIDATION_WARNING_CLASS"]]: this.validationStatus === "warning",
                [formClasses["VALIDATION_ERROR_CLASS"]]: this.validationStatus === "error",
                [formClasses["VALIDATION_SUCCESS_CLASS"]]: this.validationStatus === "success",
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled
            }, exportParts: this.exportparts ? this.exportparts : null }, this.label ? (h("gxg-label", { labelPosition: this.labelPosition, center: this.centerLabel, width: this.labelWidth }, this.label, requiredLabel(this))) : null, h("div", { class: "textarea-wrapper", part: "textarea-wrapper" }, h("textarea", { ref: el => (this.textArea = el), class: {
                "form-element": true,
                textarea: true,
                "textarea--resize": this.resize
            }, placeholder: this.placeholder, disabled: this.disabled, onInput: this.handleInput, onChange: this.handleChange.bind(this), value: this.value, rows: this.ai ? 1 : this.rows, required: this.required, style: { height: this.height, maxHeight: this.maxHeight }, part: "textarea", onFocus: this.focusHandler, onBlur: this.blurHandler, onKeyDown: this.keyDownHandler }), this.toolTip ? formTooltipLogic(this, true) : null), !this.toolTip ? formMessageLogic(this) : null));
    }
    static get is() { return "gxg-form-textarea"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["form-textarea.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-textarea.css"]
        };
    }
    static get properties() {
        return {
            "singleLine": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute forces the textarea to be as tall as an input text. When the textarea gets focus, it ais as tall as the \"height: property."
                },
                "attribute": "single-line",
                "reflect": true,
                "defaultValue": "false"
            },
            "ai": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property it is for using the textarea for the ai-assistant in ide-web (Mercury)."
                },
                "attribute": "ai",
                "reflect": true,
                "defaultValue": "false"
            },
            "toolTip": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute displays a tooltip message, instead of a block message below the control"
                },
                "attribute": "tool-tip",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute gives the component error styles"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The textarea label"
                },
                "attribute": "label",
                "reflect": true
            },
            "labelPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "LabelPosition",
                    "resolved": "\"above\" | \"below\" | \"end\" | \"start\"",
                    "references": {
                        "LabelPosition": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::LabelPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label position"
                },
                "attribute": "label-position",
                "reflect": true,
                "defaultValue": "\"above\""
            },
            "labelWidth": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label width"
                },
                "attribute": "label-width",
                "reflect": false
            },
            "centerLabel": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Centers the label"
                },
                "attribute": "center-label",
                "reflect": false,
                "defaultValue": "false"
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The max-width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "maxHeight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The max-height"
                },
                "attribute": "max-height",
                "reflect": false
            },
            "height": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The textarea height"
                },
                "attribute": "height",
                "reflect": false,
                "defaultValue": "\"auto\""
            },
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The textarea placeholder"
                },
                "attribute": "placeholder",
                "reflect": false
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The textarea value"
                },
                "attribute": "value",
                "reflect": true
            },
            "rows": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The number of rows"
                },
                "attribute": "rows",
                "reflect": false,
                "defaultValue": "4"
            },
            "warning": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute gives the component warning styles"
                },
                "attribute": "warning",
                "reflect": false,
                "defaultValue": "false"
            },
            "hideValidationMessage": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute will show a validation message if the input has an error"
                },
                "attribute": "hide-validation-message",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the component disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Make the radio-buttons required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The required message if this input is required and no value is provided (optional). If this is not provided, the default browser required message will show up"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            },
            "resize": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Allow or not text area resize"
                },
                "attribute": "resize",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "shrink": {}
        };
    }
    static get events() {
        return [{
                "method": "input",
                "name": "input",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Returns the textarea value"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "change",
                "name": "change",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Returns the textarea value"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "enter",
                "name": "enter",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the enter keydown event. It emits the actual textarea value. Used for the Ai-Assistant"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "arrowUpPressed",
                "name": "arrowUpPressed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the ArrowUp keydown event. Only available if ai is true."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=form-textarea.js.map
